import { NgClass, NgForOf, NgIf } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { RoleTypeEnum } from '@enums/role-type.enum';
import { environment } from '@environments/environment';
import { RoleManagerHelper } from '@helpers/role-manager.helper';
import { CurrentUserV2Interface } from '@interfaces/current-user-v2.interface';
import { SignalRMessage } from '@interfaces/signal-r-message.interface';
import { ServiceRequestCreatedSignalRInterface } from '@interfaces/singnal-r/service-request-created-signal-r.interface';
import { TimezoneInterface } from '@interfaces/timezone/timezone.interface';
import { UserTimezoneInterface } from '@interfaces/timezone/user-timezone.interface';
import { TIME_ZONE_DATA } from '@properties/local-storage.properties';
import { DEFAULT_TIMEZONE } from '@properties/timezone.properties';
import * as Sentry from '@sentry/angular';
import { CurrentUserHttpService } from '@services/current-user-http.service';
import { CurrentUserProfileHttpService } from '@services/current-user-profile-http.service';
import { LocalStorageService } from '@services/local-storage.service';
import { TimezoneHttpService } from '@services/timezone/timezone-http.service';
import { TimezoneSharedService } from '@services/timezone/timezone-shared.service';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ToastrService } from 'ngx-toastr';
import { filter, first, interval, Observable, of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { InternalGroupChatService } from 'src/app/internalGroupChat/internal-group-chat.service';
import { BusinessUnit, ILoggedInUserViewModel } from 'src/app/model/common.model';
import { FilesService } from 'src/app/service/files.service';
import { HeaderService } from 'src/app/service/header.service';
import { MemberService } from 'src/app/service/member.service';
import { IAssignedRole, ICurrentLoationPayLoad, IMemberClaims } from 'src/app/service/memeber.model';
import { NetSuiteService } from 'src/app/service/net-suite.service';
import * as timeZones from 'src/assets/api-data/timezoneList.json';
import { Constant, DefaultGUID, RoleName } from '../../../../@shared/constants/Constant';
import { ProfileSharedService } from '../../../../pages/v2/profile/services/profile-shared.service';
import { LoginService } from '../../../../service/login.service';
import { ServiceRequestService } from '../../../../service/service-request.service';
import { EventConstant } from '../../../../sse/event.constant';
import { SignalrService } from '../../../../sse/signalr.service';
import { HeaderMobileComponent } from '../header-mobile/header-mobile.component';
import { NotificationsComponent } from '../notifications/notifications.component';

declare var $: any;

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    NgClass,
    SelectDropDownModule,
    FormsModule,
    NgIf,
    NgForOf,
    MatIconModule,
    MatButtonModule,
    HeaderMobileComponent,
    NotificationsComponent,
    MatRadioModule,
    FormsModule,
    MatMenuModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, AfterContentInit, OnDestroy {
  @Output() signOutClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isMenuOpenChange: EventEmitter<boolean> = new EventEmitter();
  @Output() isUserMenuChange: EventEmitter<boolean> = new EventEmitter();
  @Input() isMenuOpen?: boolean;

  public user: ILoggedInUserViewModel;
  public currentActivePage: string = '';
  public roleName = RoleName;
  public getMembersLocationInterval: Subscription = new Subscription();
  public currentLocationPayLoad: ICurrentLoationPayLoad;
  public incomingMessage = 0;
  public isDownloadButtonShow: boolean = true;
  public timeZones: any;
  public selectedTimezone: TimezoneInterface = this.timezoneSharedService.selectedTimezone ?? DEFAULT_TIMEZONE;
  public isTimeZoneLock: boolean = false;
  public memberSettingTimeZone;
  public isShowNotificationButton = true;
  public isShowNewNotificationButton: boolean;
  protected isShowGroupChatButton = true;
  public isInternalReadOnly: boolean = false;
  public loader: boolean = false;
  isShowCreateServiceRequestButton = false;
  timezoneConfig = {
    displayKey: 'title',
    search: true,
    placeholder: 'Select Timezone',
    height: '400px',
  };
  timezones = this.timezoneSharedService.timezonesList;
  isCustomerRole = this.roleManagerHelper.isCustomerRole();
  isCurrentUserPicture = false;
  currentUserPicture = 'assets/img/v2/general/no-avatar.svg';
  userAbbreviation = '';
  isUserDropDownopen = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private serviceRequestService: ServiceRequestService,
    private _loginService: LoginService,
    private toastr: ToastrService,
    private router: Router,
    private signalRService: SignalrService,
    private _fileService: FilesService,
    private _memberService: MemberService,
    private _headerService: HeaderService,
    private _netsuiteService: NetSuiteService,
    private _internalGroupChatService: InternalGroupChatService,
    private _serviceRequestService: ServiceRequestService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly timezoneSharedService: TimezoneSharedService,
    private readonly localStorageService: LocalStorageService,
    private readonly timezoneHttpService: TimezoneHttpService,
    private readonly roleManagerHelper: RoleManagerHelper,
    private readonly profileSharedService: ProfileSharedService,
    private readonly currentUserProfileHttpService: CurrentUserProfileHttpService,
    private readonly currentUserHttpService: CurrentUserHttpService,
    private readonly memberService: MemberService
  ) {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.userAbbreviation = this.user.firstName.charAt(0) + this.user.lastName.charAt(0);
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this.checkCurrentActivatedPage();
    this.getCurrentUserPicture();
    this.subscribeOnCurrentUserProfileUpdates();
    this._fileService.profileUrl.subscribe(url => {
      this.profileUrl = url;
    });
    this._loginService.isDownloadButtonShowAction$.subscribe(value => {
      this.isDownloadButtonShow = value;
    })
    this.serviceRequestService.isTimeZoneLockAction$.subscribe(value => {
      this.isTimeZoneLock = value;
    })
    this._loginService.moblieDeviceToggle.subscribe(value => {
      $('.sidebar-toggle').click();
    })
    let url = window.location.href;
    if (url.includes('dashboard')) {
      this.isDownloadButtonShow = true;
    }
    else {
      this.isDownloadButtonShow = false;
    }
    this.checkMemberPreference();

    if (this.user.role == RoleName.Accounting) {
      this._netsuiteService.getCustomerList().pipe(switchMap((customerList) => of(customerList))).subscribe((customerList) => {
          this._netsuiteService.netSuiteCustomerList$.next(customerList);
      })
    }
  }
  public checkCurrentActivatedPage() {
    this._headerService.currentActivePage.subscribe(x => {
      this.currentActivePage = x;
    })
  }
  public timeZone: any;
  public url: any;
  public profileUrl: string;

  private checkMemberPreference() {
    let settings = JSON.parse(localStorage.getItem('MemberPreferenceSettings'))
    if (settings != null && settings.fromDate != null) {
      this.memberSettingTimeZone = JSON.parse(localStorage.getItem('MemberPreferenceSettings')).selectedTimeZone;
    }
  }

  ngOnInit(): void {
    this.handleRouteDetails();
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isShowNotificationButton = this.user.role === RoleTypeEnum.CustomerAdmin || this.user.role === RoleTypeEnum.CustomerCoordinator 
    || this.user.role === RoleTypeEnum.ExecutiveAdmin || this.user.role === RoleTypeEnum.Management || this.user.role === RoleTypeEnum.Coordinator;
    this.isShowGroupChatButton = this.user.role === RoleTypeEnum.CustomerAdmin || this.user.role === RoleTypeEnum.CustomerCoordinator;
    /* The below code is subscribing to an event called 'refreshRolesAction' emitted by the
    '_headerService' service. When the event is emitted, the code inside the arrow function will be
    executed. It updates the 'user' property with the value of 'updatedUserDetail' if it is truthy,
    otherwise it keeps the current value of 'user'. */
    this._headerService.refreshRolesAction.subscribe(
      (updatedUserDetail) => this.user = !!updatedUserDetail ? updatedUserDetail : this.user
    );
    if (this.user.profile != null) {
      this.profileUrl = this.user.profile.filePath;
    }
    else this.profileUrl = null;

    this.timeZones = (timeZones as any).default;
    this.timeZone = JSON.parse(localStorage.getItem('timeZoneData'));
    this._internalGroupChatService.messageEventListener();
    if (this.user.role == RoleName.ExecutiveAdmin || this.user.role == RoleName.Coordinator || this.user.role == RoleName.Management) {
      this.incomingMessageCountEventListener();
      this.serviceRequestCreatedEventListener();
    }
    this.url = environment.baseUrl;

    this.checkMemberPreference();

    if (this.user && (this.user.role == this.roleName.VendorDriver || this.user.role == this.roleName.VendorCoordinator)) {
      this.getMembersLocationInterval.add(interval(15000).subscribe(() => {
          navigator.geolocation.getCurrentPosition((position) => {
            this.currentLocationPayLoad = {
              memberId: this.user.memberId,
              currentLocation: {
                latitude: position.coords.latitude.toString(),
                longitude: position.coords.longitude.toString(),
              timeStamp: new Date()
            }
          }
            if (this.currentLocationPayLoad.currentLocation.latitude && this.currentLocationPayLoad.currentLocation.longitude) {
              this._memberService.saveMembersCurrentLocation(this.currentLocationPayLoad);
            }
          });
      }));
    }

    this.getUserTimezone();
    this.populateUserDataForSentry();
  }

  ngAfterContentInit() {
    this._serviceRequestService.isTimeZoneLockAction$.subscribe(() => {
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.getMembersLocationInterval.unsubscribe();
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  handleRouteDetails(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
      this.isShowCreateServiceRequestButton = !this.router.url.includes('create-service-request');
      this.changeDetectorRef.markForCheck();
    });
  }

  incomingMessageCountEventListener() {
    this.signalRService.sseEventListener(EventConstant.incomingMessageCountEvent);
    this.signalRService.eventDataChange.subscribe(value => {
      if (value.eventName == EventConstant.incomingMessageCountEvent) {
        this.incomingMessage = value.data;
        if (this.incomingMessage) {
          this.toastr.info('You have a new message!', 'Information', { timeOut: 6000, positionClass: 'toast-top-center' }).onTap.subscribe(() => this.toasterClickedHandler());
        }
      }
    });
  }

  serviceRequestCreatedEventListener() {
    this.signalRService.sseEventListener(EventConstant.serviceRequestCreatedEvent);

    this.signalRService.eventDataChange.pipe(
      filter(
        (event: SignalRMessage<ServiceRequestCreatedSignalRInterface>) => event.eventName === EventConstant.serviceRequestCreatedEvent
      ),
        debounceTime(100),
        distinctUntilChanged(
          (
            a: SignalRMessage<ServiceRequestCreatedSignalRInterface, { ServiceRequestId: string }>,
            b: SignalRMessage<ServiceRequestCreatedSignalRInterface, { ServiceRequestId: string }>
        ): boolean =>
          a.extraParams.ServiceRequestId === b.extraParams.ServiceRequestId
      )
    ).subscribe((): void => {
        this.NotificationToaster('New Service Request is created!', 'Information');
      });
  }

  public NotificationToaster(msg: string, title: string): void {
    setTimeout(() => {
      this.toastr.info(msg, title, { timeOut: 6000, positionClass: 'toast-top-center' });
    }, 3000);

  }

  ngOnChanges() {
    this._loginService.isDownloadButtonShowAction$.subscribe(value => this.isDownloadButtonShow = value);
  }

  signOut() {
    this.signOutClicked.emit(true);
  }

  toasterClickedHandler() {
    this.router.navigate(['/messages']);
  }

  download() {
    if (Constant.isSideMenuOpen == true) {
      $('.sidebar-toggle').click();
      Constant.isSideMenuOpen = !Constant.isSideMenuOpen;
    }
    Constant.download('contentAbc');
  }

  selectTimezone(event: { value: TimezoneInterface }): void {
    this.selectedTimezone = event.value;
    this.timezoneSharedService.timezoneChange.next({
      timezone: this.selectedTimezone,
      isLocal: false,
    });
    this.localStorageService.setCurrentTimezone(this.selectedTimezone);
    this.timezoneSharedService.selectedTimezone = this.selectedTimezone;

    // INFO: for back compatibility. In the future, refactor it and delete
    Constant.selectedTimeZone = this.selectedTimezone.localTime;
    Constant.selectedTimeZoneShortValue = this.selectedTimezone.title;
    Constant.selectedGMTValue = this.selectedTimezone.gmt;
    Constant.selectedOffsetTime = String(this.selectedTimezone.offset);

    this.localStorageService.setValue(TIME_ZONE_DATA, JSON.stringify({
        selectedTimeZone: this.selectedTimezone.localTime,
        selectedTimeZoneShortValue: this.selectedTimezone.title,
      selectedGMTValue: this.selectedTimezone.gmt
    }));

    this.serviceRequestService.timZoneChange.next(Constant.selectedTimeZoneShortValue);
    this.changeDetectorRef.markForCheck();
  }

  clickDropDown(id) {
    $('#' + id + ' .search-container :input').focus();
  }

  switchRole(role: IAssignedRole): void {
    this.loader = true;
    this.getMemberClaimsBasedOnRoleId(role.roleId).subscribe((newClaims) => {
      if (newClaims.length > 0) {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.user.role = role.roleName;
        this.user.roleId = role.roleId;
        this.user.claims = newClaims;
        localStorage.setItem('user', JSON.stringify(this.user));
        this.loader = false;
        this.redirectToRoleRespectiveDashboard();
        this.populateUserDataForSentry();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        this.loader = false;
        this.toastr.error('Unable to switch the role', 'Error', { positionClass: 'toast-top-center', timeOut: 6000 });
      }
    });
  }

  switchOrganization(organization: BusinessUnit) {
    this.loader = true;
    this.user.businessUnitId = organization.id;
    this.user.businessUnitName = organization.name;
    this.user.roleId = DefaultGUID;
    this.localStorageService.setCurrentUserDetails(this.user);
    this.memberService.getMemberDetails().subscribe(
      (user) => {
        this.localStorageService.setCurrentUserDetails(user);
        this.redirectToRoleRespectiveDashboard(user?.role);
        this.populateUserDataForSentry();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      () => {
        this.loader = false;
        this.toastr.error('Unable to switch the organization', 'Error', { positionClass: 'toast-top-center', timeOut: 6000 });
      }
    );
  }

  private getMemberClaimsBasedOnRoleId(roleId: string): Observable<IMemberClaims[]> {
    return this._memberService.getMemberClaimsBasedOnRoleId(roleId);
  }

  public redirectToRoleRespectiveDashboard(role?: string): void {
    this._loginService.redirectToRespectiveDashboard(role || this.user?.role);
  }

  onCreateServiceRequest(): void {
    void this.router.navigate(['/v2/create-service-request/step1']).then();
  }

  private getUserTimezone(): void {
    if (this.timezoneSharedService.selectedTimezone) {
      this.selectedTimezone = this.timezoneSharedService.selectedTimezone;
      this.selectTimezone({ value: this.selectedTimezone });
    } else {
      this.detectUserTimezone();
    }
  }

  private detectUserTimezone(): void {
    this.timezoneHttpService.detectUserTimezone()
      .pipe(first())
      .subscribe((response: UserTimezoneInterface): void => {
        const timezone = this.timezoneSharedService.timezones.get(response.name) ?? DEFAULT_TIMEZONE;

        this.selectTimezone({ value: timezone });
      });
  }

  getCurrentUserPicture(): void {
    const currentUserPictureUrlSub = this.currentUserProfileHttpService.currentUserPictureUrl$.pipe(filter((response) => Boolean(response))).subscribe({
      next: (url: string) => {
        if (url) {
          this.isCurrentUserPicture = true;
          this.currentUserPicture = url;
          this.changeDetectorRef.markForCheck();
        }
      },
    });
    this.subscriptions.push(currentUserPictureUrlSub);
  }

  subscribeOnCurrentUserProfileUpdates(): void {
    const currentUserProfileUpdatesSub = this.profileSharedService.profileUpdates$
      .subscribe({
      next: (status: boolean) => {
        if (status) {
          this.user = this.localStorageService.getCurrentUserDetails();
          this.changeDetectorRef.markForCheck();
        }
      },
    });
    this.subscriptions.push(currentUserProfileUpdatesSub);
  }

  clickUserDropDownOpen(): void {
    this.isUserMenuChange.emit(true);
  }
  clickUserDropDownClose(): void {
    this.isUserMenuChange.emit(false);
  }

  private populateUserDataForSentry(): void {
    const user = this.user;
    if (user) {
      Sentry.setUser({
        id: user.memberId,
        email: user.emailID,
        username: user.fullName,
        role: user.role
      });
    }
  }
}
